<template>
    <div>
        <Title title="交易记录" path="/my"/>
        <div class="fxboex tabpanel">
            <van-tabs v-model="tab_active">
                <van-tab v-for="(c, i) in tabs" :key="i" :title="c"/>
            </van-tabs>
        </div>
        <div class="tabpanel_lh"></div>

        <van-calendar :show-confirm="true" :default-date="defaultDate"/>

        <div class="userwrap">
            <div class="accbox">

                <div class="page-loading" v-if="isInit === true">
                    <van-skeleton title :row="8" />
                </div>
                <template v-else>
                    <div class="costhd">
                        <div class="tm" @click="selectDate">{{dateText}}<i></i></div>
                        <div class="bm">
                            月统计：
                            <span><i>FXB</i><em class="f">{{blane[0]}}</em></span>
                            <span><i>积分</i><em class="j">{{blane[1]}}</em></span>
                        </div>
                        <!--                                            <span class="del"></span>-->
                    </div>
                    <template v-if="list.length>0">

                        <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
                            <van-list v-model="isLoading"
                                      finished-text="没有了~"
                                      :immediate-check="false"
                                      :finished="isFinished"
                                      :error.sync="isError"
                                      :error-text="list.length>0?'读取失败':''"
                                      @load="onLoadMore">

                                <van-checkbox-group v-model="ids">
                                <div class="costitem" v-for="(c, i) in list" :key="i">
                                    <van-swipe-cell>
                                        <van-cell>
                                    <div class="con">
<!--                                        <input type="checkbox" class="ipt" v-model="ids" :value="c.cid">-->
                                        <div class="vanchk ipt">
                                            <van-checkbox :name="c.cid" shape="square" checked-color="#f4882a" icon-size="12px" />
                                        </div>
                                        <div class="lft">
                                            <div :class="['type','type'+c.type_id]"></div>
                                            <div class="name">{{c.type_name}}</div>
                                            <div class="time">{{c.create_time}}</div>
                                        </div>

                                        <div class="amt">
                                            <div class="amtbx">
                                            <span class="z" v-if="c.type_id === 4 || c.type_id === 6 || c.type_id === 7">
                                                <em>积分</em><template v-if="c.integral>0">+</template>{{ c.integral }}
                                            </span>
                                                <template v-else-if="c.type_id === 5">
                                                    <span v-if="c.integral" class="d"><em>积分</em>{{c.integral}}</span>
                                                </template>
                                            </div>

                                            <div class="amtbx">
                                            <span class="x" v-if="c.type_id === 5"><em>FXB</em>{{ c.amt }}</span>
                                            <span class="s" v-else-if="c.type_id === 1 || c.type_id === 2 || c.type_id === 3 || c.type_id === 7">
                                                <em>FXB</em><template v-if="c.amt>0">+</template>{{ c.amt }}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                        </van-cell>
                                        <template #right>
                                            <van-button square type="danger" @click="delcost(i)" text="删除" />
                                        </template>
                                    </van-swipe-cell>
                                </div>
                                </van-checkbox-group>
                            </van-list>
                        </van-pull-refresh>

                        <div class="fxboex accbtm">
                            <div class="conx">
                                <van-checkbox v-model="ischkAll" shape="square" checked-color="#f4882a" icon-size="18px">全选</van-checkbox>
                                <button @click="delcostpl">删除</button>
                                <span class="seleng" v-if="ids.length">已选择<b>{{ids.length}}</b>场</span>
                            </div>
                        </div>
                    </template>
                    <van-empty description="没有记录~" v-else/>
                </template>

            </div>
        </div>

<!--        <van-calendar v-model="showCalendar" :show-confirm="false" color="#f4882a" @confirm="onGetCostDate" formatter="month"/>-->
        <van-popup position="bottom" v-model="showCalendar">
        <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onConfirmDate"
                @cancel="onCancelDate"
        />
        </van-popup>

        <!--                :formatter="formatter"-->
    </div>
</template>

<script>
    import '../../assets/css/user.css'
    import Title from '../public/title'
    export default {
        name: "cost",
        components: {
            Title
        },
        data (){
            let vm = this
            return {
                list: [],
                blane: [0, 0],
                tabs: ['全部', '充值', '订阅', '签到', '返还'],
                tab_active: 0,
                page: 1,
                ft: 0,
                isInit: true,
                isRefresh: false,
                isLoading: false,
                isLoadingError: false,
                isFinished: false,
                isError: false,
                defaultDate: new Date(),

                ids: [],
                ischkAll: false,

                showCalendar: false,
                minDate: new Date(2020, 0, 1),
                maxDate: new Date(),
                currentDate: new Date(),
                dateText: vm.formatter(new Date()),
                dateVal: '',
            }
        },
        watch: {
            '$route': {
                handler: function (v) {
                    if(v.name === 'mycost') {
                        this.ischkAll = false
                        this.ids = []
                    }
                }
            },
            tab_active(i){
                this.ft = i
                // this.dateVal = ''
                // this.dateText = this.formatter(new Date())
                this.page = 1
                // this.isRefresh = true
                this.isFinished = false
                this.isError = false
                this.$backTop()
                this.getdata()
            },
            ischkAll(v){
                let that = this
                that.ids = []
                if(v){
                    that.ids = []
                    that.list.forEach(function (c) {
                        that.ids.push(c.cid)
                    })
                }
            },
            list(v){
                let that = this
                let tmplist = []
                v.forEach(function(c){
                    tmplist.push(c.cid)
                })
                that.ids.forEach(function (k, i) {
                    if(tmplist.indexOf(k) === -1){
                        that.ids.splice(i, 1)
                    }
                })
            }
        },
        activated() {
            let that = this
            that.getdata()
        },
        methods: {
            formatter(time, type=1) {
                let year = time.getFullYear()
                let month = time.getMonth() + 1
                if(type === 1)
                    return year + '年' + month + '月'
                else
                    return year + '-' + month
            },
            selectDate(){
              this.showCalendar = true
            },
            onConfirmDate(v){
                // console.log(v)
                this.dateText = this.formatter(v)
                this.dateVal = this.formatter(v, 2)
                this.onCancelDate()
                this.$toast.loading({message: '请稍后...', duration: 0, forbidClick: true})
                // this.page = 1
                // this.isInit = true
                this.onRefresh()
            },
            onCancelDate(){
                this.showCalendar = false
            },

            // formatDate(date) {
            //     return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            // },
            // onGetCostDate(v){
            //   console.log(v)
            //     this.showCalendar = false
            // },

            onRefresh(){
                let that = this
                this.page = 1
                this.isLoading = false
                this.isFinished = false
                this.isError = false
                setTimeout(function () {
                    that.getdata()
                }, 100)
            },
            onLoadMore(){
                let that = this
                if(!that.isLoadingError)
                    that.page++
                that.getdata()
            },
            getdata(){
                let that = this
                this.$get(that.$api.member_cost, {ft: that.ft, page: that.page, tm: that.dateVal}).then(function (res) {
                    that.$toast.clear()
                    if(res.code === 1) {
                        if(that.page === 1){
                            that.list = []
                            // that.$backTop()
                        }
                        let blanes = res.data.blane
                        that.blane = blanes
                        let tmplist = res.data.list
                        if(tmplist.length > 0) {
                            if (that.isRefresh) {
                                that.list = tmplist
                            } else {
                                that.list = that.list.concat(tmplist)
                            }
                        }
                        else{
                            that.isFinished = true
                        }
                        that.isInit = false
                    }
                    else{
                        that.isError = true
                    }
                })
                .catch(function () {
                    that.isError = true
                    that.isLoadingError = true
                })
                .finally(function () {
                    that.isRefresh = false
                    that.isLoading = false
                })
            },
            delcost(i){
                // console.log(i)
                let that = this
                that.$dialog.confirm({
                    title: '确认',
                    message: '确定删除吗？',
                }).then( () => {
                    let id = that.list[i].cid
                    that.$post(that.$api.member_cost_delete, {id: id}).then(function (res) {
                        if(res.code === 1){
                            that.$toast.success(res.msg)
                            that.list.splice(i, 1)
                        }
                    })
                }).catch(()=>{})

            },
            delcostpl(){
                // console.log(this.ids)
                let that = this
                if(this.ids.length===0){
                    this.$toast('请选择一项')
                    return
                }
                that.$dialog.confirm({
                    title: '确认',
                    message: '确定删除选择项吗？',
                }).then( () => {
                    that.$post(that.$api.member_cost_action, {ids: that.ids.join(',')}).then(function (res) {
                        // console.log(res)
                        if(res.code === 1){
                            that.$toast.success(res.msg)

                            //页面删除选中项
                            let del_item_list = []
                            that.list.forEach(function (c, i) {
                                if(that.ids.indexOf(c.cid) > -1)
                                    del_item_list.push(i)
                            })
                            del_item_list.reverse().forEach(function (c) {
                                that.list.splice(c, 1)
                            })
                            that.ids = []
                        }
                    })
                }).catch(()=>{})
            },
        },
    }
</script>

<style scoped>
.accbox{margin-bottom: 50px;}
.van-pull-refresh{min-height: calc(100vh - 200px);}
.van-cell{padding:0;}
.van-button{height:100%;}
</style>
